export const PASSWORD_MIN_LENGTH = 12;

const COMMON_PASSWORD_FRAGMENTS = [
  "123456",
  "azerty",
  "boardgame",
  "letmein",
  "password",
  "qwerty",
  "test123",
  "thetavern",
  "tavern",
  "welcome",
];

const normalize = (value) =>
  typeof value === "string"
    ? value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
    : "";

const getPersonalFragments = ({ username, email } = {}) => {
  const fragments = [username, email?.split("@")[0]]
    .map(normalize)
    .filter((value) => value.length >= 3);

  return [...new Set(fragments)];
};

export const evaluatePassword = (password, context = {}) => {
  const value = typeof password === "string" ? password : "";
  const normalizedPassword = normalize(value);
  const personalFragments = getPersonalFragments(context);

  const checks = [
    {
      id: "minLength",
      valid: value.length >= PASSWORD_MIN_LENGTH,
    },
    {
      id: "uppercase",
      valid: /[A-Z]/.test(value),
    },
    {
      id: "lowercase",
      valid: /[a-z]/.test(value),
    },
    {
      id: "number",
      valid: /\d/.test(value),
    },
    {
      id: "symbol",
      valid: /[^A-Za-z0-9]/.test(value),
    },
    {
      id: "notCommon",
      valid:
        value.length > 0 &&
        !COMMON_PASSWORD_FRAGMENTS.some((fragment) =>
          normalizedPassword.includes(fragment)
        ),
    },
    {
      id: "notPersonal",
      valid:
        value.length > 0 &&
        !personalFragments.some((fragment) =>
          normalizedPassword.includes(fragment)
        ),
    },
  ];

  return {
    checks,
    isValid: checks.every((check) => check.valid),
    score: checks.filter((check) => check.valid).length,
  };
};
